"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BadgedIcon = require("./BadgedIcon");
Object.keys(_BadgedIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BadgedIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BadgedIcon[key];
    }
  });
});